// Generated by scripts/write-version.js — do not edit.
export const release = "2026.3.2";
export const buildStamp = "20261008172527";
const buildStampDefault = "20261008172527";
export default buildStampDefault;
